import React, { Component } from 'react';
import Input from '@material-ui/core/Input';
import NativeSelect from '@material-ui/core/NativeSelect';
import { withStyles } from '@material-ui/core/styles';
var styles = {
  select: {
    width: '100%'
  }
};

var Dropdown = function Dropdown(props) {
  var renderOptions = function renderOptions() {
    if (props.options) {
      return props.options.map(function (option, i) {
        return React.createElement("option", {
          key: i,
          value: option.get('value'),
          "data-testid": "option-".concat(i + 1)
        }, option.get('value'));
      });
    }
  };

  var change = function change(e) {
    return props.onSelect(e.target.value);
  };

  return React.createElement(NativeSelect, {
    className: props.classes.select,
    value: props.value,
    onChange: change,
    input: React.createElement(Input, {
      "data-testid": "select",
      name: "dropdown",
      id: "dropdown"
    }),
    "data-test": props.testClass
  }, React.createElement("option", {
    value: 0,
    "data-testid": "option-0"
  }), renderOptions());
};

export default withStyles(styles)(Dropdown);